import React, {useCallback, useEffect, useState} from "react";
import {InputSearchOption} from "./style/InputStyle";
import SimmsSelect from "../select/SimmsSelect";
import {isMobile} from "../commonmethod/CommonMethod";

function filterAssets(assets, searchTxt, selectedOption) {
    const query = (searchTxt ?? "").trim().toLowerCase();
    if (!query) {
        return assets;
    }

    const field = selectedOption?.value ?? "assetName";
    if (field === "handler") {
        return assets.filter((each) =>
            each.asset?.handler?.name?.toLowerCase().includes(query),
        );
    }

    return assets.filter((each) => each.asset?.assetName?.toLowerCase().includes(query));
}

function SearchDummyText({assets, setAssetsSearch, options}) {
    const [searchTxt, setSearchTxt] = useState("");
    const [selectedOption, setSelectedOption] = useState(options?.[0]);

    const applyFilter = useCallback(
        (text, option) => {
            setAssetsSearch(filterAssets(assets, text, option));
        },
        [assets, setAssetsSearch],
    );

    useEffect(() => {
        applyFilter(searchTxt, selectedOption);
    }, [assets, searchTxt, selectedOption, applyFilter]);

    const inputListener = (e) => {
        setSearchTxt(e.target.value);
    };

    const handleOnKeyPress = (e) => {
        if (e.key === "Enter") {
            applyFilter(e.target.value, selectedOption);
        }
    };

    return (
        <div className="diligence-asset-search flex min-w-0 flex-1 items-center gap-2">
            {options?.length > 0 && (
                <SimmsSelect
                    onChange={(v) => setSelectedOption(options[v])}
                    options={options}
                    data={selectedOption?.id}
                />
            )}
            <InputSearchOption
                value={searchTxt}
                isMobile={isMobile}
                placeholder={options?.length > 0 ? selectedOption?.placeHolder : "자산명 검색"}
                id="diligence_asset_search_input"
                onChange={inputListener}
                onKeyDown={handleOnKeyPress}
            />
        </div>
    );
}

export default SearchDummyText;
